'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _StaticBlog = require('../sections/StaticBlog');

var _StaticBlog2 = _interopRequireDefault(_StaticBlog);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

require('../../styles/templates/blog.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Blog = function Blog() {
  (0, _classCallCheck3.default)(this, Blog);

  var sections = window.shopifySections || new _shopifySectionsManager2.default();
  sections.register('static-blog', function (section) {
    return new _StaticBlog2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = Blog;


new Blog();